export const AGENCY = {
  name: "Despega GT",
  tagline: "Agencia de viajes",
  address: "Ciudad de Guatemala, Guatemala",
  phoneDisplay: "+502 3999 0332",
  whatsapp: "50239990332",
  instagram: "https://www.instagram.com/despegagt?igsh=MWJ4bmR0eHd2bDdybg==",
  facebook: "https://www.facebook.com/despegagt",
  tiktok: "https://www.tiktok.com/@despega.gt?_r=1&_t=ZS-93hurkr3J8D",
};

export function whatsappLink(message) {
  return `https://wa.me/${AGENCY.whatsapp}?text=${encodeURIComponent(message)}`;
}

export const ORIGINS = ["Guatemala (GUA)"];

export const TRIP_TYPES = ["Paquete completo", "Vuelo + hotel", "Solo vuelo"];

export const REGIONS = ["Caribe", "Centroamérica", "Sudamérica", "Europa", "Norteamérica"];

export const TOURS = [
  {
    slug: "isla-mujeres",
    title: "Tour por Isla Mujeres",
    place: "Cancún, México",
    region: "Caribe",
    duration: "7 horas",
    price: 55,
    image: "/Tours/isla-mujeres.jpg",
    badge: "Más vendido",
    description:
      "Navega en catamarán desde Cancún hacia Isla Mujeres. Barra libre, snorkel en un arrecife con estatuas submarinas y comida buffet en un club de playa privado.",
  },
  {
    slug: "isla-saona",
    title: "Tour por Isla Saona",
    place: "Punta Cana, Rep. Dominicana",
    region: "Caribe",
    duration: "Día completo",
    price: 65,
    image: "/Tours/isla-saona.jpg",
    description:
      "Visita la icónica Isla Saona con catamarán y lancha rápida. Aguas turquesa, piscinas naturales con estrellas de mar y buffet típico.",
  },
  {
    slug: "guatape-penol",
    title: "Guatapé y El Peñol",
    place: "Antioquia, Colombia",
    region: "Sudamérica",
    duration: "Día completo",
    price: 45,
    image: "/Tours/guatape_penol.jpg",
    description:
      "Recorrido por El Retiro, las históricas escalinatas de El Peñol, almuerzo con vistas al embalse y caminata por los zócalos de Guatapé.",
  },
  {
    slug: "cartagena-4-islas",
    title: "4 Islas + Plancton en Cartagena",
    place: "Cartagena, Colombia",
    region: "Sudamérica",
    duration: "Día completo",
    price: 70,
    image: "/Tours/cartagena_4_islas.jpg",
    badge: "Nuevo",
    description:
      "Tour por las Islas del Rosario con snorkel, Cholón, Agua Azul y Playa Tranquila, más actividad nocturna de plancton bioluminiscente.",
  },
  {
    slug: "panama-canal",
    title: "Lo Mejor de Panamá",
    place: "Ciudad de Panamá, Panamá",
    region: "Centroamérica",
    duration: "Día completo",
    price: 50,
    image: "/Tours/panama_canal.jpg",
    description:
      "Recorrido por el Casco Antiguo, el Centro de Visitantes de Miraflores para ver el Canal en acción y visita a Albrook Mall.",
  },
  {
    slug: "madrid-bus",
    title: "Hop On Hop Off Madrid",
    place: "Madrid, España",
    region: "Europa",
    duration: "Flexible",
    price: 35,
    image: "/Tours/madrid_bus.jpg",
    description:
      "Explora Madrid a tu ritmo en un autobús turístico de dos pisos, con audioguía en 14 idiomas y paradas en los puntos icónicos de la ciudad.",
  },
  {
    slug: "eiffel-sena",
    title: "Torre Eiffel + Crucero por el Sena",
    place: "París, Francia",
    region: "Europa",
    duration: "Medio día",
    price: 165,
    image: "/Tours/eiffel_sena.jpg",
    description:
      "Recorrido panorámico por París, acceso sin filas a la Torre Eiffel (2° piso) y crucero por el río Sena.",
  },
  {
    slug: "disney-world",
    title: "Disney World",
    place: "Orlando, Estados Unidos",
    region: "Norteamérica",
    duration: "Día completo",
    price: 250,
    image: "/Tours/disneyworld.jpg",
    description:
      "Los 4 parques temáticos: Magic Kingdom, Epcot, Hollywood Studios y Animal Kingdom, con toda la magia de Disney.",
  },
];

export const PACKAGES = [
  {
    slug: "panama",
    name: "Panamá",
    place: "Ciudad de Panamá, Panamá",
    nights: 3,
    price: 4936,
    image: "/Trips/PANAMA.jfif",
    includes: [
      "Boletos aéreos ida y vuelta",
      "Maleta de mano de 22 libras",
      "Traslado aeropuerto — hotel — aeropuerto",
      "3 noches de alojamiento",
    ],
    featured: true,
  },
  {
    slug: "peten",
    name: "Petén",
    place: "Flores, Petén",
    nights: 3,
    price: 2752,
    image: "/Trips/PETEN.jpg",
    includes: [
      "Boletos aéreos ida y vuelta",
      "Traslado aeropuerto — hotel — aeropuerto",
      "3 noches de alojamiento",
    ],
  },
  {
    slug: "cartagena",
    name: "Cartagena",
    place: "Cartagena, Colombia",
    nights: 3,
    price: 2995,
    image: "/Trips/COLOMBIA.jpg",
    includes: [
      "Boletos aéreos ida y vuelta",
      "Traslado aeropuerto — hotel — aeropuerto",
      "3 noches de alojamiento",
      "Desayunos diarios",
    ],
  },
];

export const FAQS = [
  {
    q: '¿Qué incluye el precio "desde"?',
    a: "Vuelo ida y vuelta desde Guatemala en tarifa básica y hotel en habitación doble para las noches indicadas. El precio final depende de fechas, disponibilidad y categoría de hotel.",
  },
  {
    q: "¿Puedo pagar en cuotas?",
    a: "Sí. Trabajamos con tarjetas de crédito locales para pagar en cuotas y también aceptamos abonos parciales antes de la salida.",
  },
  {
    q: "¿Me ayudan con la visa y el pasaporte?",
    a: "Sí, es uno de nuestros servicios. Te decimos qué documentos necesita cada destino y te acompañamos en todo el trámite de visa y pasaporte.",
  },
  {
    q: "¿Qué pasa si mi vuelo cambia o se cancela?",
    a: "Nosotros gestionamos el cambio con la aerolínea. Tienes un asesor asignado con WhatsApp directo antes, durante y después del viaje.",
  },
  {
    q: "¿Los tours y paquetes incluyen seguro de viaje?",
    a: "Los paquetes completos lo incluyen. Para tours y vuelos sueltos lo cotizamos aparte y siempre lo recomendamos.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Desde el primer día fue una experiencia increíble. Playas de agua turquesa, excelente hotel y una organización impecable.",
    name: "Andrea López",
    trip: "Cancún, 5 noches",
  },
  {
    quote:
      "La calidez de su gente, las playas infinitas y el ritmo caribeño hacen que quieras quedarte para siempre. Ideal para desconectarse.",
    name: "Carlos Méndez",
    trip: "República Dominicana",
  },
  {
    quote:
      "Colombia me sorprendió en todo sentido: la comida, la historia, la música y cada rincón lleno de vida. Repetimos este año.",
    name: "María Fernanda Ruiz",
    trip: "Colombia",
  },
];

export function formatQ(value) {
  return `Q${value.toLocaleString("es-GT")}`;
}

export function formatUSD(value) {
  return `$${value.toLocaleString("es-GT")}`;
}
